import React from "react";

function InfoKPI({ text, value, bgColor = "rgba(200,230,201,1)" }) {
  return (
    <div class="mb-2">
      <div className="text-center">
        <label htmlFor="exampleFormControlInput1" class="mb-1 fw-bold">
          {text}
        </label>
      </div>

      <div className="card text-dark mb-2" style={{ backgroundColor: bgColor }}>
        <div className="card-body1 px-1 py-1">
          <h5 className="card-title1 text-center fw-light mb-0">{value}</h5>
          {/*<p className="card-text">
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </p>*/}
        </div>
      </div>
    </div>
  );
}

export default InfoKPI;
